// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"View1_wrapper__2Ri70","topicTitle":"View1_topicTitle__3A10U"};